import { BodyText } from "@/components/ui/Text";
import { cn } from "@/lib/utils";
import { formatDate } from "date-fns";
import { Check, CircleXIcon, LoaderCircle } from "lucide-react";
import { MessageProcessingStatus } from "../types/universalChatTypes";

interface TimestampWithStatusProps {
  timestamp: string;
  status?: MessageProcessingStatus | null;
  alignmentClass?: string;
}

export function TimestampWithStatus({
  timestamp,
  status,
  alignmentClass = "text-left",
}: TimestampWithStatusProps) {
  return (
    <div
      className={cn(alignmentClass)}
      data-testid="chat-message-timestamp-with-status"
    >
      <span className="inline-flex align-middle items-center gap-1">
        {status === MessageProcessingStatus.UNPROCESSED && (
          <LoaderCircle
            className="h-3 w-3 text-tertiary animate-spin"
            role="status"
            aria-label="Loading"
          />
        )}
        {status === MessageProcessingStatus.PROCESSED && (
          <Check
            className="h-3 w-3 text-tertiary"
            role="status"
            aria-label="Processed"
          />
        )}
        {status === MessageProcessingStatus.FAILED && (
          <CircleXIcon
            className="text-red-400 h-3 w-3 text-tertiary"
            role="status"
            aria-label="Failed"
          />
        )}
        <BodyText size="xs" textColor="tertiary">
          {formatDate(new Date(timestamp), "MM/dd/yyyy h:mm a")}
        </BodyText>
      </span>
    </div>
  );
}
